import { connect } from 'react-redux';
import { fetchTestimonials } from 'common/ducks/categories';
import SubCategoryTestimonial from 'marketing/components/sub_category_testimonial';

const mapStateToProps = (state) => {
  const { testimonial } = state.categories;

  return {
    testimonial,
  };
}

export default connect(mapStateToProps, { fetchTestimonials })(SubCategoryTestimonial);
